/** Shared by discussion creation and comment schemas without importing either. */
export enum ThreadCommentVisibilityEnum {
  INTERNAL = 'INTERNAL',
  PUBLIC = 'PUBLIC',
}
